import React, { Component } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import DiscountEntry from './DiscountEntry';

import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import { connect } from 'react-redux';

import { Field, formValueSelector, reduxForm } from 'redux-form/immutable';

import Paper from 'material-ui/Paper';
import { SelectField } from 'redux-form-material-ui';

import './SubscriptionSelection.scss';

class SubscriptionSelection extends Component {
    selectSubscriptionType = type => {
        this.props.selectSubscriptionTypeHandler(type.toJS());
    };

    renderDuration = () => {
        return (
            <div
                style={{
                    justifyContent: 'center',
                    width: '100%',
                    display: 'flex',
                    marginBottom: '36px',
                }}>
                <Field
                    name="duration"
                    component={SelectField}
                    hintText="Laufzeit"
                    floatingLabelText="Laufzeit">
                    <MenuItem value="0" primaryText="Unbegrenzt" />
                    <MenuItem value="1" primaryText="1" />
                    <MenuItem value="2" primaryText="2" />
                    <MenuItem value="3" primaryText="3" />
                    <MenuItem value="4" primaryText="4" />
                    <MenuItem value="5" primaryText="5" />
                    <MenuItem value="6" primaryText="6" />
                </Field>
            </div>
        );
    };

    renderPrice = (price, coupon) => {
        if (coupon) {
            return (
                <span className="price">
                    {' '}
                    <span style={{ textDecoration: 'line-through' }}>{price}</span>{' '}
                    <span style={{ color: '#519a4d' }}>
                        {price * (1 - coupon.get('discount'))} €
                    </span>
                </span>
            );
        } else {
            return <span className="price">{price} €</span>;
        }
    };

    period = plan => {
        return 'MONAT';
    };

    subscription_type = plan => {
        switch (plan.get('payment_period')) {
            case 'monthly':
                return 'Monatsabo';
            case 'yearly':
                return 'Jahresabo';
            case 'none':
                return 'Testabo';
            default:
                return 'Monatsabo';
        }
    };

    subscription_info = plan => {
        switch (plan.get('identifier')) {
            case 'basic':
                return <p style={{ fontSize: 13, textAlign: 'center' }}>nur Inventur</p>;
            case 'pro':
                return (
                    <p style={{ fontSize: 13, textAlign: 'center' }}>
                        Inventur, Umlagerungen, Preisänderungen, Kundenbestellungen,
                        Lieferantenretouren
                        <br />
                        <br />
                        <strong>ACHTUNG</strong>
                        <br />
                        Aktuell nur für HILTES und WWS-CSV!
                        <br />
                        Advarics, FurturaRetail, ProHandel, TopM, FEE, INTERSYS folgt kurzfristig.
                    </p>
                );
            default:
                return <p style={{ fontSize: 13, textAlign: 'center' }}>nur Inventur</p>;
        }
    };
    render = () => {
        return (
            <div>
                <form>
                    <Row around="xs">
                        {this.props.plans.map(plan => {
                            return (
                                <Col xs={3} md={3} lg={3}>
                                    <Paper zDepth={1}>
                                        <div className="subscription-box">
                                            <h2>{plan.get('name')}</h2>
                                            <h3>{this.subscription_type(plan)}</h3>
                                            {this.subscription_info(plan)}
                                            {this.renderPrice(
                                                plan.get('amount'),
                                                this.props.coupons.find(
                                                    cp =>
                                                        cp.get('planVariantId') ===
                                                        this.props.planVariantId
                                                )
                                            )}
                                            <br />
                                            {plan.get('identifier') === 'test' ? (
                                                <span>Kostenloses Testabo mit folgender Einschränkung: alle gescannten (Bar-)Codes werden die letzten 3 Ziffern durch "xxx" ersetzt.</span>
                                            ) : (
                                                <div>
                                                    <span>/ {this.period(plan)} (netto zzgl. MWST)</span>
                                                    <DiscountEntry
                                                        planVariantId={plan.get('plan_variant_id')}
                                                        planId={plan.get('id')}
                                                    />
                                                </div>
                                            )}

                                            <div className="call_to_action">
                                                <RaisedButton
                                                    label="Auswählen"
                                                    primary={true}
                                                    style={{}}
                                                    onClick={() => {
                                                        this.selectSubscriptionType(plan);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </Paper>
                                </Col>
                            );
                        })}
                    </Row>
                </form>
            </div>
        );
    };
}

const selector = formValueSelector('planSelection'); // <-- same as form name

export default connect(state => {
    const duration = selector(state, 'duration');
    return {
        duration,
    };
})(reduxForm({ form: 'planSelection' })(SubscriptionSelection));
